export default __webpack_public_path__ + "static/media/get_taxi_green.40276a9c.svg";